import "./index.scss";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Avatar,
  ButtonGroup,
  Dialog,
  DialogTitle,
  Icon,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@mui/material";
import { Image, Menu } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SettingsIcon from "@mui/icons-material/Settings";
import AddDevice from "../modals/addDevice";
import GlobalSettings from "../modals/globalSettings";
import { useState } from "react";
import speedMetersDefault from "../../speedMetersDeafult.json";
import HelpIcon from "@mui/icons-material/Help";

function InboxIcon() {
  return null;
}

export default function Header() {
  const [openGlobalSettings, setOpenGlobalSettings] = useState(false);
  const [openAddDevice, setOpenAddDevice] = useState(false);
  const [more, setMore] = useState(false);

  return (
    <AppBar position="static">
      <AddDevice
        callback={(e) => {
          if (e) {
            const newCharts = [...JSON.parse(localStorage.getItem("charts"))];
            newCharts.push({
              uuid: e,
              deadBand: 10,
              speedMeters: speedMetersDefault,
            });
            localStorage.setItem("charts", JSON.stringify(newCharts));
            document.location.reload();
          }
          setOpenAddDevice(false);
        }}
        open={openAddDevice}
      />
      <GlobalSettings
        onClose={() => {
          setOpenGlobalSettings(false);
        }}
        open={openGlobalSettings}
      />
      <Dialog
        onClose={() => {
          setMore(false);
        }}
        open={more}
      >
        <DialogTitle>Please Select</DialogTitle>
        <List sx={{ pt: 0 }}>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText
                onClick={() => {
                  setOpenAddDevice(true);
                  setMore(false);
                }}
                primary="Add a New Device"
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText
                onClick={() => {
                  setOpenGlobalSettings(true);
                  setMore(false);
                }}
                primary="Settings"
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText
                onClick={() => {
                  localStorage.clear();
                  document.location.reload();
                }}
                primary="Logout"
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Dialog>
      <Toolbar>
        <Button
          onClick={() => {
            window.open("/FCS User Guide  Rev 9.pdf");
          }}
          color="inherit"
        >
          <HelpIcon />
        </Button>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <img className="header-logo" src={"/flotek.png"} />
        </Typography>
        <Button
          onClick={() => {
            setMore(true);
          }}
          color="inherit"
        >
          <SettingsIcon />
        </Button>
      </Toolbar>
    </AppBar>
  );
}
